export default "__VITE_ASSET__CmWc_DFN__"